import React, { Component } from "react";
import disableBrowserBackButton from "disable-browser-back-navigation";

import { Link } from "../utils/components/router";

export default class MALoginStart extends Component {
  componentDidMount() {
    disableBrowserBackButton();
  }
  render() {
    return (
      <section className="if6_outer section if6_section full-height">
        <div className="if6_inner">
          <main className="bootstrap-iso">
            <div className="login-form">
              <div className="container ">
                <div className="justify-content-center">
                  <div className="row col-lg-12">
                    <div className="col-lg-8">
                      <div className="modal-content card mt-two">
                        <h2 className="modal-header card-header text-secondary">
                          Mitarbeiter Anmeldung 2
                        </h2>
                        <div className="modal-body card-body mt-two m-one mb-three">
                          <form action="" method="">
                            <div className="form-group row">
                              <label
                                htmlFor="email_address"
                                className="col-md-4 col-lg-4 col-form-label text-md-right align-self-center fs-5"
                              >
                                VR-NetKey oder Alias:
                              </label>
                              <div className="col-md-6">
                                <input
                                  type="text"
                                  id="email_address"
                                  className="form-control"
                                  name="email-address"
                                  required
                                  autofocus
                                />
                              </div>
                            </div>

                            <div className="form-group row">
                              <label
                                htmlFor="password"
                                className="col-md-4 col-lg-4 col-form-label text-md-right align-self-center fs-5"
                              >
                                PIN:
                              </label>
                              <div className="col-md-6">
                                <input
                                  type="password"
                                  id="password"
                                  className="form-control"
                                  name="password"
                                  required
                                />
                              </div>
                            </div>

                            <div className="col-lg-8 offset-md-4 mt-one">
                              <Link
                                type="submit"
                                to={"/"}
                                className="btn btn-primary"
                              >
                                Anmelden
                              </Link>
                            </div>
                          </form>
                        </div>
                        <div className="modal-footer">
                          <Link className="btn btn-link">
                            Haben Sie Ihren Pin vergessen?
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </section>
    );
  }
}
